import PrimaryCategoriesNoContent from './PrimaryCategoriesNoContent';

const DesktopNavNoContent = () => {
  return (
    <div className="desktop-nav-container">
      <div className="desktop-nav-border-container">
        <nav className="desktop-nav-container__nav hmf-subheader-m hmf-py-xxs">
          <PrimaryCategoriesNoContent />
        </nav>
      </div>
    </div>
  );
};

export default DesktopNavNoContent;
